export const initializeNetworkMapBox = () => {
  // Check if mapboxgl is available globally
  if (typeof mapboxgl === 'undefined') {
    console.error('Mapbox GL JS is not loaded. Please ensure the CDN script is enqueued.');
    return;
  }

  const mapBoxToken = mapBoxData.accessToken;
  mapboxgl.accessToken = mapBoxToken;

  const mapEl = document.getElementById('network-map');
  if (!mapEl) {
    console.warn('Map element not found');
    return;
  }

  const mapDataRaw = mapBoxData.mapData;
  let mapData = null;
  try {
    mapData = JSON.parse(mapDataRaw);
  } catch (e) {
    console.error('Failed to parse map data:', e);
    return;
  }

  // Default center (Canada)
  const defaultCenter = [-106.3468, 56.1304];
  const defaultZoom = 4;

  // Create MapBox map
  const map = new mapboxgl.Map({
    container: mapEl,
    style:  mapBoxData.styleUrl || 'mapbox://styles/mapbox/streets-v11',
    // style:  mapBoxData.localStylePath || 'mapbox://styles/mapbox/streets-v11',
    center: defaultCenter,
    zoom: defaultZoom,
    cooperativeGestures: true
  });

  // Store marker positions for fitting
  let markerPositions = [];

  // Add markers
  if (Array.isArray(mapData)) {
    mapData.forEach(item => {
      if (item.map_location && typeof item.map_location.lat === 'number' && typeof item.map_location.lng === 'number') {
        const lngLat = [item.map_location.lng, item.map_location.lat];
        markerPositions.push(lngLat);

        // Create custom marker element
        const el = document.createElement('div');
        el.className = 'custom-map-marker';

        // create a child element .marker-size-element 
        const sizeEl = document.createElement('div');
        sizeEl.className = 'marker-size-element';
        el.appendChild(sizeEl);

        if (item.name) el.title = item.name;

        // Add hover and click events
        el.addEventListener('mouseenter', () => {
          el.classList.add('hover');
        });
        el.addEventListener('mouseleave', () => {
          el.classList.remove('hover');
        });
        el.addEventListener('click', () => {
          console.log('Marker clicked for:', item.name);
          
          // Remove active class and reset size for all markers
          document.querySelectorAll('.custom-map-marker').forEach(marker => {
            marker.classList.remove('active');
            // const sizeEl = marker.querySelector('.marker-size-element');
            // if (sizeEl) {
            //   sizeEl.style.width = '13px';
            //   sizeEl.style.height = '13px';
            // }
          });
          
          // Add active class and scale clicked marker to 3x
          el.classList.add('active');
          
          // Build comprehensive popup content
          let popupContent = `
            <div class="popup-content">
              <div class="left">
                <h2 class="name">${item.name}</h2>
                <div class="address">
                  ${item.address ? `${item.address}<br />` : ''}
                  ${item.phone ? `${item.phone}<br />` : ''}
                </div>
              </div>
              <div class="right">
                ${item.investigators && Array.isArray(item.investigators) && item.investigators.length > 0 ? `<div class="investigators">
                  <h3>Site Lead</h3>
                  <ul>
                    ${item.investigators.map(inv => `<li>${inv.name}</li>`).join('')}
                  </ul>
                </div>` : ''}
                ${item.care_team_members && Array.isArray(item.care_team_members) && item.care_team_members.length > 0 ? `
                <div class="care-team">
                  <h3>Network Members</h3>
                  <ul>
                    ${item.care_team_members.map(member => `<li>${member.name}</li>`).join('')}
                  </ul>
                </div>` : ''}
              </div>
            </div>
          `;

          // Close any existing popups first
          const existingPopups = document.querySelectorAll('.mapboxgl-popup');
          existingPopups.forEach(popup => popup.remove());

          // Zoom in to marker, use negative offset to move marker higher in viewport
          const zoomLevel = 10; // Adjust as needed
          const mapHeight = mapEl.offsetHeight || 600;
          // Negative Y offset moves marker up from center
          const verticalOffset = -Math.round(mapHeight * 0.2); // Move marker up by 10% of map height
          map.easeTo({ center: lngLat, zoom: zoomLevel, duration: 600, offset: [0, verticalOffset] });

          // Show popup
          let activePopup = null;
          try {
            const isMobile = window.innerWidth < 576;
            activePopup = new mapboxgl.Popup({ 
              offset: isMobile ? 10 : 25,
              closeButton: true,
              closeOnClick: false,
              className: 'custom-popup',
              maxWidth: '462px',
              anchor: isMobile ? [0, 0] : 'top'
            })
              .setLngLat(lngLat)
              .setHTML(popupContent || 'No information available')
              .addTo(map);

            console.log('Popup created successfully:', activePopup);

            // Force popup to be visible with inline styles
            setTimeout(() => {
              const popupElement = document.querySelector('.mapboxgl-popup');
              if (popupElement) {
                popupElement.style.display = 'block';
                popupElement.style.visibility = 'visible';
                popupElement.style.zIndex = '9999';
                console.log('Applied visibility styles to popup');
              } else {
                console.error('Popup element not found in DOM');
              }
            }, 100);

            // Add map click event to close popup only if not clicking on marker or popup
            const closePopupHandler = function(e) {
              const target = e.originalEvent.target;
              if (
                !target.closest('.custom-map-marker') &&
                !target.closest('.mapboxgl-popup')
              ) {
                if (activePopup) {
                  activePopup.remove();
                  activePopup = null;
                }
                // Remove active state and reset size for all markers when popup closes
                document.querySelectorAll('.custom-map-marker').forEach(marker => {
                  marker.classList.remove('active');
                  marker.style.width = '13px';
                  marker.style.height = '13px';
                });
                // Zoom back out to fit all markers
                fitMapToMarkers(markerPositions);
                map.off('click', closePopupHandler);
              }
            };
            map.on('click', closePopupHandler);

            // Add handler for popup close button
            setTimeout(() => {
              const closeBtn = document.querySelector('.mapboxgl-popup-close-button');
              if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                  // Remove active state and reset size for all markers when popup closes
                  document.querySelectorAll('.custom-map-marker').forEach(marker => {
                    marker.classList.remove('active');
                    marker.style.width = '13px';
                    marker.style.height = '13px';
                  });
                  fitMapToMarkers(markerPositions);
                });
              }
            }, 120);
          } catch (error) {
            console.error('Error creating popup:', error);
          }
        });

        // Add marker to map
        new mapboxgl.Marker(el)
          .setLngLat(lngLat)
          .addTo(map);
      }
    });
  }

  // Fit map to all markers, with more top padding to push markers toward the bottom
  const fitMapToMarkers = (markerPositions) => {
    if (!markerPositions.length) return;
    const bounds = new mapboxgl.LngLatBounds();
    markerPositions.forEach(pos => bounds.extend(pos));
    // Padding: {left, top, right, bottom}
    map.fitBounds(bounds, { padding: { left: 100, top: 230, right: 100, bottom: 0 } });
  }

  const hideUsLabelsAndBorders = () => {
    const style = map.getStyle();
    if (style && style.layers) {
      style.layers.forEach(layer => {
        // Hide US labels
        if (layer.id && (
          layer.id.includes('label') || 
          layer.id.includes('text') ||
          layer.id.includes('place') ||
          layer.id.includes('poi')
        )) {
          // Combine existing filter with US exclusion
          const existingFilter = map.getFilter(layer.id);
          const usExclusion = [
            'all',
            ['!=', ['get', 'iso_3166_1'], 'US'],
            ['!=', ['get', 'iso_3166_1_alpha_2'], 'US']
          ];
          let combinedFilter;
          if (existingFilter) {
            combinedFilter = ['all', existingFilter, ...usExclusion.slice(1)];
          } else {
            combinedFilter = usExclusion;
          }
          map.setFilter(layer.id, combinedFilter);
        }
        // Hide all US roads, highways, and related features
        const roadKeywords = [
          'road', 'highway', 'motorway', 'street', 'trunk', 'primary', 'secondary',
          'tertiary', 'minor', 'service', 'path', 'track', 'bridge', 'tunnel'
        ];
        if (layer.id && roadKeywords.some(keyword => layer.id.includes(keyword))) {
          // Combine existing filter with US exclusion
          const existingFilter = map.getFilter(layer.id);
          const usRoadExclusion = [
            'all',
            ['!=', ['get', 'iso_3166_1'], 'US'],
            ['!=', ['get', 'iso_3166_1_alpha_2'], 'US']
          ];
          let combinedFilter;
          if (existingFilter) {
            combinedFilter = ['all', existingFilter, ...usRoadExclusion.slice(1)];
          } else {
            combinedFilter = usRoadExclusion;
          }
          map.setFilter(layer.id, combinedFilter);
        }
        // Hide US state borders but keep Canadian provincial borders
        if (layer.id && (
          layer.id.includes('admin') || 
          layer.id.includes('boundary') ||
          layer.id.includes('border')
        )) {
          // Combine existing filter with US admin boundary exclusion
          const existingFilter = map.getFilter(layer.id);
          const usAdminExclusion = [
            '!', 
            ['all', 
              ['==', ['get', 'admin_level'], 1], 
              ['==', ['get', 'iso_3166_1'], 'US']
            ]
          ];
          let combinedFilter;
          if (existingFilter) {
            combinedFilter = ['all', existingFilter, usAdminExclusion];
          } else {
            combinedFilter = usAdminExclusion;
          }
          map.setFilter(layer.id, combinedFilter);
        }
      });
    }
  }

  map.on('load', () => {
    hideUsLabelsAndBorders();
    fitMapToMarkers(markerPositions);
  });
  window.addEventListener('resize', () => {
    fitMapToMarkers(markerPositions);
  });
};